import axios from "./axios-handler.service";
import { Parceiro } from "./parceiros.service";
import { TipoPlano } from "./planos.service";
const BASE_URL = "/api/Cupom";

export interface FiltroCupom {
  codCupom: string;
  termParceiro: string;
  semParceiro: boolean;
  soAtivos: boolean;
}

export interface Cupom {
  idCupom: string;
  idConsultor: number;
  nomeParceiro: string;
  codCupom: string;
  descricao: string;
  qtdLimite: number;
  dataInicio: string;
  dataFim: string;
  porcentagemDescontoCupom: number;
  porcentagemParceiro: number;
  apenasPrimeiroPlano: boolean;
  ativo: boolean;
  parceiro: Parceiro;
  tiposPlanos: TipoPlano[];
}

export class CupomService {
  static async obter(id: string | null): Promise<Cupom> {
    const response = await axios.get<Cupom>(`${BASE_URL}/Obter`, {
      params: {
        id,
      },
    });
    return response.data;
  }

  static async existeCupom(codigo: string | null, id: string): Promise<boolean> {
    const response = await axios.get<boolean>(`${BASE_URL}/ExisteCupom`, {
      params: {
        codigo,
        id
      },
    });
    return response.data;
  }
  static async listarCupons(filtros: FiltroCupom): Promise<Cupom[]> {
    const response = await axios.get<Cupom[]>(`${BASE_URL}/ListarCupons`, {
      params: filtros,
    });
    return response.data;
  }

  static async manter(cupom: Cupom, idsTipoPlano: number[]): Promise<boolean> {
    const response = await axios.post(`${BASE_URL}/Manter`, {
      cupom,
      idsTipoPlano,
    });
    return response.data;
  }
  static async deletarCupom(idCupom: string): Promise<void> {
    const response = await axios.delete(`${BASE_URL}/Deletar`, {
      params: { idCupom },
    });
    return response.data;
  }
}
